import { getEnabledElement } from "component/toolManager/enabledElements.js";

/**
 * Retrieves an array of stored pixel values from a rectangular region of an image
 *
 * @param {HTMLElement} element The DOM element enabled for
 * @param {Number} x The x coordinate of the top left corner of the sampling rectangle in image coordinates
 * @param {Number} y The y coordinate of the top left corner of the sampling rectangle in image coordinates
 * @param {Number} width The width of the of the sampling rectangle in image coordinates
 * @param {Number} height The height of the of the sampling rectangle in image coordinates
 * @returns {Array} The stored pixel value of the pixels in the sampling rectangle
 */
export default function(element, x, y, width, height, filter) {
  if (element === undefined) {
    throw new Error("getStoredPixels: parameter element must not be undefined");
  }

  x = Math.round(x);
  y = Math.round(y);
  const enabledElement = getEnabledElement(element);
  const storedPixels = [];
  let index = 0;

  if (enabledElement.image === undefined) {
    return null;
  }

  const roiArea = {
    left: x,
    top: y,
    width: width,
    height: height
  };

  const imageWidth = enabledElement.image.columns;
  const imageHeight = enabledElement.image.rows;

  const pixelData = enabledElement.image.getPixelData();
  for (let row = 0; row < height; row++) {
    for (let column = 0; column < width; column++) {
      const xPos = column + x;
      const yPos = row + y;
      if (xPos < 0 || xPos >= imageWidth || yPos < 0 || yPos >= imageHeight) {
        continue;
      }

      if (filter && filter(roiArea, xPos, yPos)) {
        continue;
      }
      const spIndex = yPos * enabledElement.image.columns + xPos;
      storedPixels[index++] = pixelData[spIndex];
    }
  }
  return storedPixels;
}
